/**
 * Whether a navigation only updates the URL or `page.state` of the page being
 * viewed: nothing is loaded and the visitor stays where they are. That is what
 * `replaceShallowState` (a shallow `goto`) produces.
 *
 * Checking `shallow` alone is not enough. SvelteKit also sets it on a real
 * back/forward navigation that lands on a history entry written by a shallow
 * update, and that one does load a page. Only the `goto` kind is a mere update.
 *
 * Takes the argument of a `beforeNavigate` / `afterNavigate` / `onNavigate`
 * callback. Not `navigating` from `$app/state`: SvelteKit 3.0 does not expose
 * `shallow` on it at runtime. Next to `navigating`, read `shallowUpdateInFlight`.
 */
export const isShallowUpdate = (
	navigation: { shallow?: boolean | null; type?: string | null } | null | undefined
): boolean => !!navigation?.shallow && navigation.type === 'goto';
